import React from 'react';
import '../styles/positions.css';

const jobContent = {
  title: 'Open positions in all locations',
  left: {
    role: 'Infrastructure Engineer',
    degree: 'Bachelor degree with 5 years experience.',
    qualification: "Major: Computer Engineering, CS, or equivalent.",
    location: "Princeton, NJ. Job entails working with & requires experience including: Managing User ID, resources & groups in an enterprise, delivering solutions using OneDrive, SharePoint, Teams & Office 365 collaboration tools, SCCM, MS Outlook. Evaluating existing infrastructure & implementing Office 365 solutions with emphasis on security ATP, Policies, Azure AD Identity Protection, CA, & Message Encryption. Relocation & travel to unanticipated locations within USA possible.",
    contact: "Send resumes to",
    email: "hr@synectiks.com",
    address: "Synectiks Inc., Attn: HR, 300 Alexander Park Dr., Suite 215, Princeton, NJ 08540."
  },
  right: {
    role: 'Software Developers II',
    degree: "Master's w/ 3 yrs exp or Bach w/ 5 yrs exp.",
    qualification: "Major: Computer Engineering, CS, or equivalent.",
    location: "Princeton, NJ. Job entails working with & requires experience including: Managing User ID, resources & groups in an enterprise, delivering solutions using OneDrive, SharePoint, Teams & Office 365 collaboration tools, SCCM, MS Outlook. Evaluating existing infrastructure & implementing Office 365 solutions with emphasis on security ATP, Policies, Azure AD Identity Protection, CA, & Message Encryption. Relocation & travel to unanticipated locations within USA possible.",
    contact: "Send resumes to",
    email: "hr@synectiks.com",
    address: "Synectiks Inc., Attn: HR, 300 Alexander Park Dr., Suite 215, Princeton, NJ 08540."
  }
};

const JobCard = ({ data }) => (
  <div className="position-job-card">
    <div className="position-job-header">
      <div className="position-job-title">{data.role}</div>
    </div>

    <div className="position-job-details">
      <p><span className="position-highlight">{data.degree}</span></p>
      <p>
        <span className="position-highlight">{data.qualification}</span><br />
        {data.location}
      </p>
      <p>
        <span className="position-highlight">{data.contact}</span>{' '}
        <a href={`mailto:${data.email}`}>{data.email}</a><br />
        <span className="position-location">{data.address}</span>
      </p>
    </div>

    <div className="position-buttons">
      <div className="position-btn">⏱ Full Time</div>
      <div className="position-btn">📍 On-Site</div>
    </div>
  </div>
);

const OpenPositions = () => {
  return (
    <div className="position-wrapper">
      <h2>{jobContent.title}</h2>
      <div className="position-container">
        <JobCard data={jobContent.left} />
        <JobCard data={jobContent.right} />
      </div>
    </div>
  );
};

export default OpenPositions;